import { useFormatMessage } from "@comparaonline/react-intl-hooks";
import { IFiltersProps } from "@comparaonline/ui-filter-list";

import { useAppContext } from "../../../../../../lib/appContext";
import { MAX_FILTERS_PER_GROUP } from "../constants";
import { isTravel } from "../../../../helpers/isTravel";

type UseModalProps = () => Pick<IFiltersProps, "maxItemsPerGroup" | "showModalText">;

export const useModalProps: UseModalProps = () => {
  const formatMessage = useFormatMessage();
  const {
    isMobile,
    businessUnitConfig: { businessCode }
  } = useAppContext();
  return isMobile || isTravel(businessCode)
    ? {}
    : {
        maxItemsPerGroup: MAX_FILTERS_PER_GROUP,
        showModalText: formatMessage("results.filters.showAllFilterGroup")
      };
};
